import { useStyles } from './styles'
import { lang } from '@/shared/constants/lang'
import { useUnit } from 'effector-react'
import { $userLanguage, $userToken } from '@/entities/user'
import { $shopItems, getShopItemsFx } from '@/entities/cases'
import { useEffect } from 'react'
import { AppTabs } from '@/shared/ui/appTabs'
import { Tab as TabType } from '@/shared/ui/appTabs'
import { ShopSupplies } from '@/widgets/shop/shopSupplies'
import { ShopPrimary } from '@/widgets/shop/shopPrimary'
import { $shopTab, changeShopTab } from '@/entities/navigation'
import { ShopSales } from '@/widgets/shop/shopSales'

// 123

export const ShopPageView = () => {
  const { classes } = useStyles()
  const userLanguage = useUnit($userLanguage)
  const shopItemList = useUnit($shopItems)
  const userToken = useUnit($userToken)
  const activeTab = useUnit($shopTab)

  const texts = lang[userLanguage].pages.shop

  const tabs: TabType[] = [
    { icon: 'shopSales', label: texts.tabs.sales, value: 0 },
    { icon: 'shopPrimary', label: texts.tabs.primary, value: 1 },
    { icon: 'shopSupplies', label: texts.tabs.supplies, value: 2 },
  ]

  useEffect(() => {
    if (userToken && !shopItemList) {
      getShopItemsFx(userToken!)
    }
  }, [userToken, shopItemList])

  return (
    <div className={classes.root}>
      <div className={classes.tabsWrapper}>
        <AppTabs tabs={tabs} activeValue={activeTab} onChange={changeShopTab} />
      </div>
      {activeTab === 0 && <ShopSales />}
      {activeTab === 1 && <ShopPrimary />}
      {activeTab === 2 && <ShopSupplies />}
    </div>
  )
}
